"use client";

import React, { useState, useRef } from 'react';
import { Pause, Play } from 'lucide-react';

const tickerItems = [
  'Universal Digital Access',
  'High-Performance Static Builds',
  'Accessibility-First Development',
  'Founded by a Senior Engineer',
  'Built in Woodstock, Georgia',
  '18 Years of Web Experience',
  'Transparent Packages, No Surprises',
];

export function CredentialTicker() {
  const [paused, setPaused] = useState(false);
  // Render 3 copies so the -33.333% reset is invisible
  const items = [...tickerItems, ...tickerItems, ...tickerItems];

  return (
    <section
      className="bg-bloom-green-deep overflow-hidden py-4 border-y border-white/5 group/ticker"
      aria-label="Our credentials"
    >
      {/* Hidden accessible list for screen readers */}
      <ul className="sr-only">
        {tickerItems.map((item) => <li key={item}>{item}</li>)}
      </ul>

      <div className="relative flex items-center">
        {/* Scrolling strip */}
        <div
          aria-hidden="true"
          className="flex select-none pointer-events-none"
          style={{
            animation: `ticker-scroll 28s linear infinite`,
            animationPlayState: paused ? 'paused' : 'running',
          }}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          // re-enable pointer events so hover works
          // (pointer-events: none was only on children)
        >
          {items.map((item, i) => (
            <span
              key={i}
              className="flex-shrink-0 flex items-center gap-4 font-sans text-xs font-bold uppercase tracking-[0.2em] text-white/90 px-10"
              style={{ pointerEvents: 'none' }}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-bloom-gold flex-shrink-0" />
              {item}
            </span>
          ))}
        </div>

        {/* Fade edge — right side masks text behind the pause button */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[hsl(var(--bloom-green-deep))] from-40% to-transparent pointer-events-none z-[5]" />

        {/* Pause / Play button — always visible, blends into the right fade */}
        <button
          onClick={() => setPaused(p => !p)}
          aria-label={paused ? 'Play credentials ticker' : 'Pause credentials ticker'}
          aria-pressed={paused}
          className="
            absolute right-3 z-10
            w-7 h-7 rounded-full
            bg-white/10 hover:bg-white/20
            flex items-center justify-center
            text-white/40 hover:text-white
            transition-colors
            focus-bloom
          "
        >
          {paused
            ? <Play size={12} aria-hidden="true" />
            : <Pause size={12} aria-hidden="true" />
          }
        </button>
      </div>
    </section>
  );
}
